import * as React from 'react';
var SizeContext = /*#__PURE__*/React.createContext(undefined);
export var SizeContextProvider = function SizeContextProvider(_ref) {
  var children = _ref.children,
      size = _ref.size;
  var originSize = React.useContext(SizeContext);
  return /*#__PURE__*/React.createElement(SizeContext.Provider, {
    value: size || originSize
  }, children);
};
export default SizeContext;